import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function Tv({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.75 2.25H2.25c-.825 0-1.5.675-1.5 1.5v9c0 .825.675 1.5 1.5 1.5H6v1.5h6v-1.5h3.75c.825 0 1.492-.675 1.492-1.5l.008-9c0-.825-.675-1.5-1.5-1.5Zm0 10.5H2.25v-9h13.5v9Z"
                fill={color}
            />
        </svg>
    );
}

export default Tv;
